export class CompSearchProjectedCompsInPoolResponse {
  isCompPoolAllowed: boolean;
  numCompsInPool: number;
}
